export const dischargeInstructionsMockData = [
  {
    dischargeId: 'DIS-001',
    patientId: 'PT-1089',
    patientName: 'David Miller',
    dischargeDate: '2023-12-04T11:30:00',
    attendingPhysician: 'Dr. Maria Garcia',
    department: 'Cardiology',
    admissionDate: '2023-11-30T09:20:00',
    diagnosisList: ['Myocardial Infarction', 'Hypertension'],
    medicationInstructions: [
      {
        medication: 'Aspirin',
        dosage: '81mg',
        frequency: 'Once daily',
        duration: 'Indefinitely',
        specialInstructions: 'Take with food'
      },
      {
        medication: 'Atorvastatin',
        dosage: '40mg',
        frequency: 'Once daily at bedtime',
        duration: 'Indefinitely',
        specialInstructions: 'Avoid grapefruit juice'
      },
      {
        medication: 'Metoprolol',
        dosage: '25mg',
        frequency: 'Twice daily',
        duration: 'Indefinitely',
        specialInstructions: 'Monitor heart rate and blood pressure'
      }
    ],
    followUpAppointments: [
      {
        specialist: 'Dr. Maria Garcia, Cardiology',
        date: '2023-12-18T10:00:00',
        location: 'Cardiology Clinic, Room 305',
        purpose: 'Post-MI follow-up'
      },
      {
        specialist: 'Cardiac Rehabilitation',
        date: '2023-12-11T14:00:00',
        location: 'Rehab Center, 2nd Floor',
        purpose: 'Initial assessment'
      }
    ],
    activityRestrictions:
      'No heavy lifting (>10 lbs) for 2 weeks. No driving for 1 week. Gradually increase walking distance daily.',
    dietaryRestrictions: 'Low sodium diet. Limit alcohol consumption.',
    specialNotes: 'Call immediately if experiencing chest pain, shortness of breath, or palpitations.',
    dischargingSurgeon: null,
    woundCare: null,
    createdBy: 'Nurse Sarah Collins',
    createdAt: '2023-12-04T10:15:00',
    status: 'Completed'
  },
  {
    dischargeId: 'DIS-002',
    patientId: 'PT-1156',
    patientName: 'Daniel Clark',
    dischargeDate: '2023-12-03T14:00:00',
    attendingPhysician: 'Dr. Amanda Lewis',
    department: 'Nephrology',
    admissionDate: '2023-11-29T15:30:00',
    diagnosisList: ['Acute Renal Failure', 'Dehydration'],
    medicationInstructions: [
      {
        medication: 'Furosemide',
        dosage: '20mg',
        frequency: 'Once daily',
        duration: '7 days',
        specialInstructions: 'Take in the morning'
      },
      {
        medication: 'Sodium Bicarbonate',
        dosage: '650mg',
        frequency: 'Twice daily',
        duration: '14 days',
        specialInstructions: 'Take after meals'
      }
    ],
    followUpAppointments: [
      {
        specialist: 'Dr. Amanda Lewis, Nephrology',
        date: '2023-12-10T11:30:00',
        location: 'Nephrology Clinic, Room 210',
        purpose: 'Follow-up blood work and evaluation'
      }
    ],
    activityRestrictions: 'No strenuous activity for 1 week.',
    dietaryRestrictions: 'Low potassium diet. Increase fluid intake to 3L daily.',
    specialNotes:
      'Monitor urine output. Call if experiencing decreased urination, increased swelling, or shortness of breath.',
    dischargingSurgeon: null,
    woundCare: null,
    createdBy: 'Nurse Amanda Rodriguez',
    createdAt: '2023-12-03T13:00:00',
    status: 'Completed'
  },
  {
    dischargeId: 'DIS-003',
    patientId: 'PT-1234',
    patientName: 'Ava Rodriguez',
    dischargeDate: '2023-12-02T16:30:00',
    attendingPhysician: 'Dr. Jennifer Adams',
    department: 'Obstetrics',
    admissionDate: '2023-11-28T10:45:00',
    diagnosisList: ['Cesarean Delivery', 'Gestational Diabetes'],
    medicationInstructions: [
      {
        medication: 'Ibuprofen',
        dosage: '600mg',
        frequency: 'Every 6 hours as needed',
        duration: '7 days',
        specialInstructions: 'Take with food'
      },
      {
        medication: 'Ferrous Sulfate',
        dosage: '325mg',
        frequency: 'Once daily',
        duration: '30 days',
        specialInstructions: 'Take with orange juice to enhance absorption'
      }
    ],
    followUpAppointments: [
      {
        specialist: 'Dr. Jennifer Adams, Obstetrics',
        date: '2023-12-16T09:00:00',
        location: "Women's Health Clinic, Room 105",
        purpose: 'Postpartum check-up'
      },
      {
        specialist: 'Lactation Consultant',
        date: '2023-12-05T13:00:00',
        location: "Women's Health Clinic, Room 110",
        purpose: 'Breastfeeding support'
      }
    ],
    activityRestrictions:
      'No heavy lifting (>10 lbs) for 6 weeks. No driving for 2 weeks. No stair climbing for 1 week.',
    dietaryRestrictions: 'Continue diabetic diet. Stay well hydrated.',
    specialNotes:
      'Call if experiencing fever, increased pain, redness or discharge from incision site, or heavy bleeding.',
    dischargingSurgeon: 'Dr. Jennifer Adams',
    woundCare: 'Keep incision clean and dry. No immersion in water for 2 weeks. Remove dressing in 48 hours.',
    createdBy: 'Nurse Jennifer Lopez',
    createdAt: '2023-12-02T15:30:00',
    status: 'Completed'
  },
  {
    dischargeId: 'DIS-004',
    patientId: 'PT-1385',
    patientName: 'James Wilson',
    dischargeDate: '2023-12-05T10:00:00',
    attendingPhysician: 'Dr. Thomas Baker',
    department: 'Internal Medicine',
    admissionDate: '2023-12-01T08:45:00',
    diagnosisList: ['Pneumonia', 'COPD Exacerbation'],
    medicationInstructions: [
      {
        medication: 'Azithromycin',
        dosage: '500mg',
        frequency: 'Once daily',
        duration: '5 days',
        specialInstructions: 'Take with or without food'
      },
      {
        medication: 'Prednisone',
        dosage: '20mg',
        frequency: 'Once daily',
        duration: '5 days, then 10mg for 5 days',
        specialInstructions: 'Take with food in the morning'
      },
      {
        medication: 'Albuterol Inhaler',
        dosage: '2 puffs',
        frequency: 'Every 4-6 hours as needed',
        duration: 'As needed',
        specialInstructions: 'Use spacer if available'
      }
    ],
    followUpAppointments: [
      {
        specialist: 'Dr. Thomas Baker, Internal Medicine',
        date: '2023-12-12T14:30:00',
        location: 'Internal Medicine Clinic, Room 405',
        purpose: 'Follow-up evaluation'
      },
      {
        specialist: 'Pulmonary Function Test',
        date: '2023-12-19T11:00:00',
        location: 'Pulmonary Lab, 3rd Floor',
        purpose: 'Assess lung function'
      }
    ],
    activityRestrictions: 'Rest as needed. Gradually increase activity as tolerated.',
    dietaryRestrictions: 'Stay well hydrated.',
    specialNotes: 'Call if experiencing increased shortness of breath, fever, or worsening cough.',
    dischargingSurgeon: null,
    woundCare: null,
    createdBy: 'Nurse Michael Chen',
    createdAt: '2023-12-05T09:15:00',
    status: 'Pending'
  },
  {
    dischargeId: 'DIS-005',
    patientId: 'PT-1421',
    patientName: 'Emma Johnson',
    dischargeDate: '2023-12-04T15:00:00',
    attendingPhysician: 'Dr. James Wilson',
    department: 'Orthopedics',
    admissionDate: '2023-12-02T11:30:00',
    diagnosisList: ['Open Reduction Internal Fixation of Right Tibia Fracture'],
    medicationInstructions: [
      {
        medication: 'Oxycodone',
        dosage: '5mg',
        frequency: 'Every 4-6 hours as needed for severe pain',
        duration: '5 days',
        specialInstructions: 'Do not drive or operate machinery'
      },
      {
        medication: 'Acetaminophen',
        dosage: '650mg',
        frequency: 'Every 6 hours as needed for mild pain',
        duration: '10 days',
        specialInstructions: 'Do not exceed 3000mg in 24 hours'
      },
      {
        medication: 'Aspirin',
        dosage: '81mg',
        frequency: 'Once daily',
        duration: '30 days',
        specialInstructions: 'For DVT prophylaxis'
      }
    ],
    followUpAppointments: [
      {
        specialist: 'Dr. James Wilson, Orthopedics',
        date: '2023-12-18T09:30:00',
        location: 'Orthopedic Clinic, Room 215',
        purpose: 'Post-operative follow-up'
      },
      {
        specialist: 'Physical Therapy',
        date: '2023-12-11T13:00:00',
        location: 'Rehabilitation Center, 1st Floor',
        purpose: 'Initial assessment and therapy plan'
      }
    ],
    activityRestrictions: 'Non-weight bearing on right leg for 6 weeks. Use crutches for mobility. No driving.',
    dietaryRestrictions: 'No specific restrictions. Ensure adequate protein intake for healing.',
    specialNotes:
      'Call if experiencing increased pain, swelling, redness, or drainage from surgical site. Keep leg elevated.',
    dischargingSurgeon: 'Dr. James Wilson',
    woundCare:
      'Keep dressing clean and dry. No showering for 48 hours. Afterwards, shower with waterproof covering over dressing.',
    createdBy: 'Nurse Amanda Rodriguez',
    createdAt: '2023-12-04T14:00:00',
    status: 'Completed'
  }
]
